import { useState, useEffect, useId } from 'react';
import { Consumer } from '@rails/actioncable';

type Stats = {
  requirements: number;
  bonus: number;
  pendingCount: number;
  wagerPercentage: number;
  wagerLeft: number;
};

export type RawStats = {
  wagered: string;
  requirements: string;
  bonus: string;
  pending_count: string;
};

const transformStats = (rawStats: RawStats): Stats => {
  const wagered = +parseFloat(rawStats.wagered).toFixed(2);
  const requirements = +parseFloat(rawStats.requirements).toFixed(2);
  const bonus = parseFloat(rawStats.bonus);
  const pendingCount = parseFloat(rawStats.pending_count);
  const wagerLeft = Math.round(requirements - wagered);
  const wagerPercentage = Math.floor((wagered / requirements) * 100.0);

  return {
    requirements,
    bonus,
    pendingCount,
    wagerLeft,
    wagerPercentage,
  };
};

const useBonus = (rawStats: RawStats): Stats => {
  const [stats, setStats] = useState<Stats>(transformStats(rawStats));
  const channelId = useId();

  const update = (newRawStats: RawStats) => {
    setStats(transformStats(newRawStats));
  };

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription = cable.subscriptions.create(
      {
        channel: 'WageringBonusesChannel',
        channelId,
      },
      {
        received: update,
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return stats;
};

export default useBonus;
